import * as Sentry from '@sentry/react';
import { redactUrl } from './appInsights';

let initialized = false;

// Scrub PII (UUIDs, numeric ids, emails) out of any URL-bearing fields before
// the event leaves the browser. Mirrors the redaction already applied to
// Application Insights telemetry so the two services stay consistent.
function beforeSend(event) {
  if (event.request?.url) {
    event.request.url = redactUrl(event.request.url);
  }
  if (Array.isArray(event.breadcrumbs)) {
    for (const crumb of event.breadcrumbs) {
      if (crumb?.data?.url) crumb.data.url = redactUrl(crumb.data.url);
      if (typeof crumb?.message === 'string' && crumb.message.includes('/')) {
        crumb.message = redactUrl(crumb.message);
      }
    }
  }
  return event;
}

export function initSentry() {
  if (initialized) return;

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_ENVIRONMENT,
    // Release is injected by @sentry/vite-plugin at build time when sourcemaps
    // are uploaded; left unset here so the plugin's value wins.
    sendDefaultPii: false,
    // App Insights owns performance traces; Sentry handles errors only.
    tracesSampleRate: 0,
    beforeSend,
  });

  initialized = true;
}
